interface CategoryNode {
  id: string | number;
  name: string;
  status: string;
  category_level: number;
  parentId?: string | number | null;
  subcategories?: CategoryNode[];
}

export const canApplyCategoryFilter = (
  categoryId: string | number,
  assetCategoryOptions: CategoryNode[]
): boolean => {
  if (!categoryId || !assetCategoryOptions?.length) {
    return false;
  }

  const findCategory = (cats: CategoryNode[]): CategoryNode | null => {
    for (const category of cats) {
      if (category.id == categoryId) {
        return category;
      }

      if (category.subcategories && category.subcategories.length > 0) {
        const found = findCategory(category.subcategories);
        if (found) return found;
      }
    }
    return null;
  };

  const category = findCategory(assetCategoryOptions);

  return category !== null && category.status === "Active";
};

interface BrandCount {
  name: string;
  count: number;
  productIds: number[];
}

export const calculateBrandCounts = (assets: any[]): BrandCount[] => {
  if (!assets || !Array.isArray(assets) || assets.length === 0) {
    return [];
  }

  const brandMap = new Map<string, number[]>();

  assets.forEach((asset) => {
    const normalizedBrand = (asset.product_brand || "Unknown")
      .trim()
      .toLowerCase();
    const existingIds = brandMap.get(normalizedBrand) || [];
    existingIds.push(asset.id);
    brandMap.set(normalizedBrand, existingIds);
  });

  const results: BrandCount[] = Array.from(brandMap.entries())
    .map(([brandName, productIds]) => ({
      name: brandName?.toUpperCase(),
      count: productIds.length,
      productIds: productIds,
    }))
    .sort((a, b) => b.count - a.count);

  return results;
};
